import React from "react";
import PropTypes from "prop-types";
import { Row } from "src/client/js/view/components/Grid";
import Panel from "wonderbly-components/lib/Panel";
import ShippingCountry from "./ShippingCountry";
import ShippingOptions from "./ShippingOptions";

import partition from "lodash/partition";
import get from "lodash/get";

import "./Shipping.scss";

const Shipping = (props) => {
  const tracked = ["express", "options"];
  const filteredItems = partition(props.items, (item) => {
    const shippingType = item.options;
    // Adding different options until we update Prismic fields throughout
    return ["standard", "estimated", ...tracked].includes(shippingType);
  });

  const shippingEstimates = filteredItems[0];
  const shippingCountry = filteredItems[1];

  return (
    <section className="shipping shipping-ii container-guttered">
      <Panel className="shipping-panel" border="shadow">
        <Row colsToRowsOn="fablet-down">
          <h3 className="text-mega">{props.title}</h3>
          <div className="shipping-country-wrapper">
            {shippingCountry && (
              <ShippingCountry
                countryIso={props.values.countryIso}
                onChange={props.handleChange}
                setFieldValue={props.setFieldValue}
                eagleCountries={get(props, "model.eagleModel.countries", [])}
                prismicCountries={get(
                  props,
                  "countries.country.countryOption",
                  []
                )}
                states={props.regionStates[props.values.countryIso] || []}
                header={shippingCountry[0].header}
                isTwoColumnLayout={props.isTwoColumnLayout}
              />
            )}
          </div>
          <div className="shipping-estimates-wrapper">
            {shippingEstimates &&
              shippingEstimates.map((item, i) => {
                const shippingType = item.options;
                return (
                  <ShippingOptions
                    key={`${shippingType}-${i}`}
                    header={item.header}
                    description={item.description}
                    shippingDates={props.shippingDates}
                    isLoading={props.isLoading}
                    countryModel={props.model.countryModel}
                    isTracked={tracked.includes(shippingType)} // Tracked prop for express shipping
                  />
                );
              })}
          </div>
        </Row>
      </Panel>
    </section>
  );
};

Shipping.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  order: PropTypes.shape({
    shipping: PropTypes.object,
    shipmentTotal: PropTypes.object,
  }),
  values: PropTypes.shape({
    countryIso: PropTypes.string.isRequired,
  }),
  model: PropTypes.shape({
    countryModel: PropTypes.shape({
      iso: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  shippingDates: PropTypes.arrayOf(PropTypes.object),
  regionStates: PropTypes.object,
  handleChange: PropTypes.func,
  setFieldValue: PropTypes.func,
  isLoading: PropTypes.bool,
  isTwoColumnLayout: PropTypes.bool,
};

export default Shipping;
